let ctx = null;

function getCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) ctx = new AC();
  }
  if (ctx && ctx.state === "suspended") ctx.resume();
  return ctx;
}

// Tom alto e audível. Usa onda "square" (mais forte que sine) e ganho alto para
// cortar o barulho do ambiente da loja.
function tone(freq, duration, { type = "square", when = 0, gain = 0.95 } = {}) {
  const c = getCtx();
  if (!c) return;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.value = freq;
  o.connect(g);
  g.connect(c.destination);
  const t = c.currentTime + when;
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(gain, t + 0.006);
  g.gain.setValueAtTime(gain, t + duration - 0.03);
  g.gain.exponentialRampToValueAtTime(0.0001, t + duration);
  o.start(t);
  o.stop(t + duration + 0.02);
}

// Sucesso: dois bips agudos subindo, claros e fortes — "deu certo".
export function beepSuccess() {
  tone(988, 0.13, { type: "square", gain: 0.95 });
  tone(1319, 0.18, { type: "square", gain: 0.95, when: 0.12 });
}

// Repetido: alarme grave e insistente (duplo), bem diferente do sucesso — "atenção, repetido".
export function beepDuplicate() {
  tone(196, 0.2, { type: "sawtooth", gain: 1.0 });
  tone(160, 0.2, { type: "square", gain: 0.9 });
  tone(196, 0.2, { type: "sawtooth", gain: 1.0, when: 0.26 });
  tone(160, 0.2, { type: "square", gain: 0.9, when: 0.26 });
}

// Erro genérico: zumbido grave longo.
export function beepError() {
  tone(140, 0.4, { type: "sawtooth", gain: 1.0 });
  tone(120, 0.4, { type: "square", gain: 0.85 });
}
